/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CrossReferenceIds } from '../models/CrossReferenceIds';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class AllTransactionsVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async allTransactionsVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/transactions/get`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static async allTransactionsVFindIdsThatDontExist(
        requestBody?: CrossReferenceIds,
    ): Promise<Array<string>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/transactions/check-ids-exist`,
            body: requestBody,
        });
        return result.body;
    }

}